import type { AiPowerTranslation } from './en';

/** Hindi. Pending review by native speakers, as the note in the interface says. */
export const aiPowerHi: AiPowerTranslation = {
  mcp: {
    preset: {
      label: 'किसी तैयार सेवा से शुरू करें',
      other: 'कोई और सेवा (उसका पता लिखें)',
      hint: 'ये वे पते हैं जो सेवाएँ ख़ुद प्रकाशित करती हैं। नाम और पता अपने-आप भरने के लिए एक चुनें।',
      docs: 'इस पते के बारे में सेवा का अपना पन्ना',
      verified: 'पता {{date}} को सेवा के पन्ने से मिलाया गया।',
      summaries: {
        'intercom-us': 'Intercom में बातचीत, संपर्क और सहायता केंद्र के लेख खोजें।',
        'intercom-eu': 'Intercom में बातचीत, संपर्क और सहायता केंद्र के लेख खोजें।',
        gorgias: 'अपने Gorgias हेल्प डेस्क के टिकट और ग्राहक पढ़ें।',
        stripe: 'Stripe में ग्राहक, भुगतान, सदस्यताएँ और रिफ़ंड खोजें।',
        klaviyo: 'Klaviyo में ग्राहक प्रोफ़ाइल, सूचियाँ और अभियान के नतीजे पढ़ें।',
        calendly: 'Calendly में उपलब्धता और तय की गई बैठकें देखें।',
        linear: 'Linear में इशू और प्रोजेक्ट खोजें और पढ़ें।',
        notion: 'Notion में पन्ने और डेटाबेस खोजें और पढ़ें।',
        atlassian: 'Jira के इशू और Confluence के पन्ने खोजें और पढ़ें।',
        asana: 'Asana में टास्क और प्रोजेक्ट खोजें और पढ़ें।',
        monday: 'monday.com में बोर्ड और आइटम खोजें और पढ़ें।',
        sentry: 'Sentry में त्रुटियाँ और इशू खोजें।',
        github: 'GitHub पर रिपॉज़िटरी, इशू और पुल रिक्वेस्ट खोजें और पढ़ें।',
      },
      notes: {
        'intercom-us': 'जब आपका Intercom वर्कस्पेस अमेरिका में होस्ट हो तब इसे इस्तेमाल करें।',
        'intercom-eu': 'जब आपका Intercom वर्कस्पेस यूरोपीय संघ में होस्ट हो तब इसे इस्तेमाल करें।',
        gorgias: 'साइन इन करते समय Gorgias आपके खाते का नाम पूछता है।',
        stripe: 'OAuth से साइन इन करें, या Stripe एजेंट API कुंजी को टोकन के रूप में चिपकाएँ।',
        linear: 'Linear का एक सिर्फ़ पढ़ने वाला पता भी है: https://mcp.linear.app/mcp/readonly।',
        asana: 'अगर Asana क्लाइंट आईडी माँगे, तो Asana के डेवलपर कंसोल में एक ऐप बनाएँ और उसे लिखें।',
        github: 'GitHub पर एक पर्सनल एक्सेस टोकन बनाएँ और उसे टोकन के रूप में चिपकाएँ।',
      },
      auth: {
        oauth: 'आप ब्राउज़र से साइन इन करते हैं। टोकन की ज़रूरत नहीं।',
        oauth_or_token: 'आप ब्राउज़र से साइन इन करते हैं, या सेवा से मिला टोकन चिपकाते हैं।',
        token: 'सेवा आपको एक टोकन देती है, जिसे आप चिपकाते हैं।',
      },
    },
    auth: {
      none: 'न साइन-इन, न टोकन',
      token: 'टोकन {{masked}}',
      oauth: '{{host}} के ज़रिए साइन इन',
      needsReconnect: 'साइन-इन काम करना बंद हो गया। दोबारा साइन इन करें।',
      expires: '{{time}} से पहले अपने-आप नया हो जाता है',
    },
    actions: {
      signIn: 'साइन इन करें',
      signInAgain: 'दोबारा साइन इन करें',
      signOut: 'साइन आउट करें',
      edit: 'बदलें',
      remove: 'हटाएँ',
      catalog: 'संसाधन और तैयार अनुरोध',
      signInLabel: '{{name}} में साइन इन करें',
      signOutLabel: '{{name}} से साइन आउट करें',
      editLabel: '{{name}} बदलें',
      removeLabel: '{{name}} हटाएँ',
      catalogLabel: 'देखें कि {{name}} टूल के अलावा क्या देती है',
    },
    signIn: {
      title: '{{name}} में साइन इन करें',
      description:
        'आप साइन इन करने और Hamnivo को अनुमति देने के लिए सेवा पर जाते हैं, फिर यहाँ लौट आते हैं। Hamnivo आपका पासवर्ड कभी नहीं देखता।',
      continue: 'सेवा पर जाएँ',
      manual: 'क्लाइंट आईडी लिखें',
      manualHint:
        'सिर्फ़ तब, जब सेवा ने माँगी हो: कुछ सेवाएँ Hamnivo को ख़ुद को दर्ज करने नहीं देतीं। वहाँ क्लाइंट बनाते समय नीचे का रीडायरेक्ट पता इस्तेमाल करें।',
      redirect: 'रीडायरेक्ट पता',
      clientId: 'क्लाइंट आईडी',
      clientSecret: 'क्लाइंट सीक्रेट',
      clientSecretHint: 'सिर्फ़ तब, जब सेवा ने दिया हो।',
      needsClient: 'यह सेवा Hamnivo को ख़ुद को दर्ज करने नहीं देती। सेवा से मिली क्लाइंट आईडी लिखें।',
      leaving: 'सेवा पर जा रहे हैं…',
      signedOut: '{{name}} से साइन आउट हो गया।',
    },
    signOut: {
      title: '{{name}} से साइन आउट करें?',
      body: 'Hamnivo सेवा से कहता है कि वह यह पहुँच भूल जाए, और सहेजा गया साइन-इन मिटा देता है। टूल रहते हैं, पर दोबारा साइन इन करने या टोकन जोड़ने तक चल नहीं सकते।',
      confirm: 'साइन आउट करें',
    },
    callback: {
      title: 'साइन इन हो रहा है',
      working: 'साइन-इन पूरा हो रहा है…',
      done: '{{name}} में साइन इन हो गया।',
      synced: 'उसके टूल “टूल” में दिख रहे हैं: चालू करने से पहले हर एक को देख लें।',
      syncFailed: 'साइन इन हो गया, पर टूल अभी सूचीबद्ध नहीं हो पाए। सेवा को दोबारा जाँचें।',
      refused: 'सेवा ने साइन-इन की अनुमति नहीं दी।',
      failed: 'साइन-इन पूरा नहीं हुआ।',
      ended: 'यह साइन-इन ख़त्म हो चुका है या किसी और ने शुरू किया था। इसे टूल पन्ने से दोबारा शुरू करें।',
      missing: 'यह पन्ना साइन-इन पूरा करने के लिए है। टूल पन्ने से साइन-इन शुरू करें।',
      back: 'टूल पर लौटें',
    },
    edit: {
      title: '{{name}} बदलें',
      description: 'उसका नाम, पता या टोकन बदलें।',
      label: 'नाम',
      url: 'पता',
      token: 'नया टोकन',
      tokenHint:
        'सहेजा हुआ रखने के लिए इसे ख़ाली छोड़ें। नया टोकन साइन-इन की जगह लेता है। यह एन्क्रिप्ट करके रखा जाता है और दोबारा नहीं दिखता।',
      removeToken: 'सहेजा हुआ टोकन हटाएँ',
      removeSignIn: 'साइन-इन हटाने के लिए “साइन आउट करें” इस्तेमाल करें।',
      urlWarning:
        'पता बदलने पर टूल समीक्षा में लौट जाते हैं और सेवा की सूची दोबारा पढ़ी जाती है। सहेजा हुआ टोकन तभी रहता है जब नया पता उसी साइट पर हो, और साइन-इन ख़त्म हो जाता है।',
      save: 'बदलाव सहेजें',
      saved: '{{name}} अपडेट हो गई।',
      nothing: 'कुछ नहीं बदला।',
    },
    remove: {
      title: '{{name}} हटाएँ?',
      body: 'उसके टूल बंद हो जाते हैं और सूची से हट जाते हैं, उन पर रुके अनुरोध रद्द हो जाते हैं, और उसका टोकन या साइन-इन मिट जाता है। उन्होंने जो किया वह लॉग में रहता है। वही पता आप बाद में दोबारा जोड़ सकते हैं।',
      confirm: 'हटाएँ',
      done: '{{name}} हटा दी गई।',
    },
    catalog: {
      title: '{{name}} क्या देती है',
      description:
        'पिछली जाँच में सेवा ने टूल के अलावा जो संसाधन और तैयार अनुरोध सूचीबद्ध किए। उद्धरण चिह्नों में लिखी बातें सेवा की हैं।',
      checked: '{{time}} को सूचीबद्ध',
      neverChecked: 'पहले सेवा को जाँचें, तभी दिखेगा कि वह क्या देती है।',
      resources: 'संसाधन',
      resourcesNote:
        'सेवा के दिए दस्तावेज़ और डेटा। “Read a resource” टूल वाले एजेंट सिर्फ़ वही पढ़ सकते हैं जो आप चालू करें।',
      noResources: 'सेवा कोई संसाधन सूचीबद्ध नहीं करती।',
      readable: 'एजेंट इसे पढ़ सकते हैं',
      readableLabel: 'एजेंटों को {{name}} पढ़ने दें',
      readableHint: 'सिर्फ़ “Read a resource” टूल से।',
      type: 'प्रकार',
      size: 'आकार',
      uri: 'पता',
      fromService: 'सेवा की ओर से',
      prompts: 'तैयार अनुरोध',
      promptsNote: 'सेवा के दिए तैयार अनुरोध। ये आपके देखने के लिए सूचीबद्ध हैं; एजेंट इन्हें इस्तेमाल नहीं करते।',
      noPrompts: 'सेवा कोई तैयार अनुरोध सूचीबद्ध नहीं करती।',
      arguments: 'माँगता है',
      required: 'ज़रूरी',
      needTool: 'एजेंट संसाधन “Read a resource” टूल से पढ़ते हैं। उसे टूल पन्ने पर जोड़ें, फिर किसी एजेंट को दें।',
      saved: 'सहेजा गया।',
      loading: 'सेवा जो देती है वह लोड हो रहा है',
    },
  },
  web: {
    badge: 'वेबसाइट',
    add: 'वेबसाइट जोड़ें',
    line: {
      reading: 'अभी पढ़ी जा रही है',
      waiting: 'पढ़े जाने के इंतज़ार में',
      never: 'अभी पढ़ी नहीं गई',
      last: 'पढ़ी गई {{time}}',
    },
    dialog: {
      addTitle: 'वेबसाइट जोड़ें',
      addDescription:
        'Hamnivo किसी वेबसाइट के पन्ने पढ़ता है और उन्हें अपडेट रखता है, ताकि AI उनसे जवाब दे सके। यह साइट की robots.txt मानता है, धीरे-धीरे पढ़ता है और सिर्फ़ उसी साइट पर रहता है जिसका पता आप देते हैं।',
      editTitle: 'वेबसाइट की सेटिंग',
      brand: 'ब्रांड',
      url: 'वेबसाइट का पता',
      urlHint:
        'वह पन्ना जहां से पढ़ना शुरू करना है, जैसे https://example.com/help/। सिर्फ़ उसी फ़ोल्डर के पन्ने पढ़े जाते हैं।',
      urlRequired: 'वेबसाइट का पता डालें।',
      urlInvalid: 'https:// से शुरू होने वाला पूरा पता डालें।',
      name: 'नाम',
      nameHint: 'स्रोतों की सूची में दिखता है। खाली छोड़ने पर साइट का नाम इस्तेमाल होता है।',
      mode: 'क्या पढ़ना है',
      modeSite: 'पूरी साइट',
      modeSiteHint: 'उसका साइटमैप और पन्नों के बीच के लिंक, पते के फ़ोल्डर के अंदर।',
      modePage: 'सिर्फ़ यही पन्ना',
      modePageHint: 'सिर्फ़ वह पता जो आपने डाला।',
      maxPages: 'ज़्यादा से ज़्यादा पन्ने',
      maxPagesHint: '1 से 500 तक।',
      maxPagesInvalid: '1 से 500 तक की पूर्ण संख्या डालें।',
      maxDepth: 'कितने लिंक आगे जाना है',
      maxDepthHint: 'पहले पन्ने से गिनती। 0 रखने पर सिर्फ़ पहला पन्ना और साइटमैप पढ़े जाते हैं।',
      maxDepthInvalid: '0 से 5 तक की पूर्ण संख्या डालें।',
      schedule: 'दोबारा पढ़ना',
      visibility: 'इससे जवाब कौन पा सकता है',
      submit: 'वेबसाइट जोड़ें',
      save: 'बदलाव सेव करें',
      added: '{{name}} जोड़ी गई। Hamnivo अभी इसे पढ़ना शुरू करता है।',
      saved: 'वेबसाइट की सेटिंग सेव हो गई।',
      later: 'पहली बार पढ़ने में कुछ मिनट लग सकते हैं। आप यह पन्ना छोड़ सकते हैं।',
    },
    schedule: { daily: 'हर दिन', weekly: 'हर हफ़्ते', manual: 'सिर्फ़ जब मैं कहूं' },
    panel: {
      title: 'वेबसाइट',
      address: 'पता',
      reads: 'क्या पढ़ती है',
      readsSite: 'पूरी साइट: {{pages}} पन्नों तक, {{depth}} लिंक की गहराई',
      readsPage: 'सिर्फ़ यही पन्ना',
      schedule: 'दोबारा पढ़ना',
      next: 'अगली बार पढ़ना {{time}}',
      pages: 'सहेजे गए पन्ने',
      lastRead: 'आख़िरी बार पढ़ी गई',
      never: 'यह वेबसाइट अभी पढ़ी नहीं गई।',
      state: {
        queued: 'पढ़े जाने के इंतज़ार में',
        running: 'अभी पढ़ी जा रही है',
        succeeded: 'पढ़ी गई',
        partial: 'पढ़ी गई, कुछ दिक़्क़तों के साथ',
        failed: 'पढ़ी नहीं जा सकी',
        never: 'अभी पढ़ी नहीं गई',
      },
      polling: 'वेबसाइट पढ़े जाने के दौरान Studio हर कुछ सेकंड में नई जानकारी जांचता है।',
      summary: {
        title: 'आख़िरी बार पढ़ने में क्या हुआ',
        added: 'नए: {{total}}',
        updated: 'बदले: {{total}}',
        unchanged: 'जैसे थे वैसे: {{total}}',
        retired: 'हटाए गए: {{total}}',
        sitemaps: 'पढ़े गए साइटमैप: {{total}}',
        leftOut: 'छोड़े गए',
        skipped: {
          robots: 'साइट पाठकों को दूर रहने को कहती है (robots.txt): {{total}}',
          offsite: 'दूसरी साइट पर: {{total}}',
          noindex: 'जो पन्ने इंडेक्स न करने को कहते हैं: {{total}}',
          type: 'वेब पन्ना या PDF नहीं: {{total}}',
          duplicate: 'पहले पढ़े पन्ने की कॉपी: {{total}}',
          empty: 'पढ़ने लायक टेक्स्ट नहीं: {{total}}',
        },
        problems: 'जो पढ़े नहीं जा सके',
        truncated:
          'पन्नों की सीमा या समय की वजह से पढ़ना सारे पन्नों तक पहुंचने से पहले रुक गया। ज़्यादा पढ़ने के लिए सेटिंग में सीमा बढ़ाएं।',
        robots: {
          read: 'साइट की robots.txt पढ़ी गई और मानी गई।',
          missing: 'साइट पर robots.txt नहीं है, इसलिए सभी पन्नों की इजाज़त थी।',
          unreadable: 'साइट की robots.txt पढ़ी नहीं जा सकी, इसलिए कुछ नहीं पढ़ा गया।',
        },
      },
      actions: {
        sync: 'अभी पढ़ें',
        syncLabel: '{{name}} अभी पढ़ें',
        queued: 'Hamnivo थोड़ी देर में {{name}} पढ़ेगा।',
        settings: 'सेटिंग',
        settingsLabel: '{{name}} की सेटिंग',
        showPages: 'पन्ने देखें',
        hidePages: 'पन्ने छिपाएं',
      },
      pagesList: {
        title: 'पन्ने',
        loading: 'पन्ने लोड हो रहे हैं',
        empty: 'अभी कोई पन्ना नहीं।',
        columns: { address: 'पता', state: 'स्थिति', note: 'टिप्पणी' },
        states: { ok: 'पढ़ा गया', failed: 'नहीं पढ़ सका', gone: 'हटाया गया' },
      },
    },
  },
  http: {
    title: 'कस्टम टूल',
    description:
      'अपनी खुद की वेब सेवा जोड़ें। उसका OpenAPI विवरण इंपोर्ट करें, या एक अनुरोध हाथ से लिखें। हर अनुरोध एक टूल बन जाता है, जो किसी भी एजेंट के इस्तेमाल से पहले आपकी समीक्षा का इंतज़ार करता है।',
    importLabel: 'विवरण इंपोर्ट करें',
    writeLabel: 'अनुरोध लिखें',
    loading: 'कस्टम टूल लोड हो रहे हैं',
    empty: 'अभी कोई कस्टम टूल नहीं।',
    source: {
      kinds: { openapi: 'इंपोर्ट किया गया विवरण', manual: 'हाथ से लिखा' },
      status: { active: 'चालू', disabled: 'बंद' },
      toolStatus: { review: 'समीक्षा बाक़ी', enabled: 'चालू', disabled: 'बंद' },
      tools: 'टूल: {{total}}',
      review: 'समीक्षा बाक़ी: {{total}}',
      auth: {
        none: 'कोई क्रेडेंशियल नहीं',
        bearer: 'टोकन {{masked}}',
        header: '{{header}} हेडर में गुप्त मान {{masked}}',
      },
      spec: 'विवरण “{{title}}” {{version}} से',
      requests: '{{name}} के अनुरोध',
      open: 'खोलें',
      openLabel: 'टूल {{tool}} खोलें',
      editRequest: 'बदलें',
      editRequestLabel: 'अनुरोध {{tool}} बदलें',
      imported: 'इंपोर्ट किया गया: बदलने के लिए उसे फिर इंपोर्ट करें।',
      addRequest: 'अनुरोध जोड़ें',
      importMore: 'और इंपोर्ट करें',
      edit: 'बदलें',
      editLabel: '{{name}} बदलें',
      turnOff: 'बंद करें',
      turnOn: 'चालू करें',
      remove: 'हटाएँ',
      removeLabel: '{{name}} हटाएँ',
      off: 'यह सेवा बंद है, इसलिए इसके टूल नहीं चल सकते।',
    },
    service: {
      name: 'सेवा का नाम',
      nameHint: 'सूची में उसे किस नाम से ढूँढेंगे, जैसे “ऑर्डर सिस्टम”।',
      baseUrl: 'सेवा का पता',
      baseUrlHint:
        'हर अनुरोध इस पते के नीचे जाता है, जैसे https://api.example.com/v1। यह https:// से शुरू होता है और इसमें ? या # नहीं होता।',
      auth: {
        legend: 'अनुरोध कैसे साइन इन करते हैं',
        none: 'कोई क्रेडेंशियल नहीं',
        noneHint: 'ऐसी सेवा के लिए जिसे इसकी ज़रूरत नहीं।',
        bearer: 'एक टोकन',
        bearerHint: '“Authorization: Bearer …” के रूप में भेजा जाता है।',
        header: 'हेडर में एक गुप्त मान',
        headerHint: 'आपके बताए हेडर में भेजा जाता है।',
        token: 'टोकन',
        tokenHint: 'एन्क्रिप्ट करके रखा जाता है। सिर्फ़ उसके आख़िरी अक्षर दिखते हैं।',
        headerName: 'हेडर का नाम',
        headerNameHint: 'जैसे X-Api-Key।',
        value: 'गुप्त मान',
        valueHint: 'एन्क्रिप्ट करके रखा जाता है। सिर्फ़ उसके आख़िरी अक्षर दिखते हैं।',
      },
      errors: {
        name: 'सेवा को एक नाम दें।',
        baseUrl: 'पता लिखें, https:// से शुरू करके।',
        token: 'टोकन कम से कम 8 अक्षरों का होता है।',
        headerName: 'अक्षर, अंक, हाइफ़न और अंडरस्कोर इस्तेमाल करें।',
        value: 'गुप्त मान लिखें।',
      },
    },
    importDialog: {
      title: 'OpenAPI विवरण इंपोर्ट करें',
      titleMore: '{{name}} में और टूल इंपोर्ट करें',
      description:
        'Hamnivo JSON या YAML में OpenAPI 3 विवरण पढ़ता है और वे अनुरोध दिखाता है जिन्हें टूल बनाया जा सकता है। जब तक आप उन्हें जोड़ते नहीं, कुछ सहेजा नहीं जाता।',
      where: 'विवरण कहाँ है?',
      paste: 'मेरे पास टेक्स्ट या फ़ाइल है',
      address: 'वह एक वेब पते पर है',
      text: 'विवरण',
      textHint: 'JSON या YAML यहाँ चिपकाएँ, या फ़ाइल चुनें। 9,00,000 अक्षरों तक।',
      file: 'फ़ाइल चुनें',
      fileTooBig: 'यह फ़ाइल बहुत बड़ी है। जिन अनुरोधों की ज़रूरत नहीं उन्हें छोड़ दें, या उन्हें हाथ से लिखें।',
      specUrl: 'विवरण का पता',
      specUrlHint:
        'जैसे https://api.example.com/openapi.json। Hamnivo इसे अपने सर्वर से पढ़ता है, हर पते पर लागू नियमों के तहत।',
      read: 'विवरण पढ़ें',
      needText: 'पहले विवरण चिपकाएँ या फ़ाइल चुनें।',
      needUrl: 'पहले विवरण का पता लिखें।',
      found: '“{{title}}” {{version}}: {{count}} अनुरोध टूल बन सकते हैं।',
      foundUntitled: '{{count}} अनुरोध टूल बन सकते हैं।',
      none: 'इस विवरण का कोई अनुरोध टूल नहीं बन सकता।',
      readAgain: 'दूसरा विवरण पढ़ें',
      servers: 'विवरण के अनुसार सेवा यहाँ है',
      serversHint: 'यह विवरण का टेक्स्ट है। इस्तेमाल से पहले पता जाँच लें।',
      authUnsupported:
        'विवरण ऐसा साइन-इन माँगता है ({{kind}}) जो टूल आपकी ओर से नहीं कर सकते। अगर सेवा हेडर में टोकन या कुंजी भी लेती है, तो नीचे वही चुनें।',
      operations: 'टूल बनने वाले अनुरोध',
      operationsHint:
        'हर एक टूल बनता है जो आपकी समीक्षा का इंतज़ार करता है। जो सिर्फ़ पढ़ते हैं वे आपके लिए चुने गए हैं। जो कुछ बदलते हैं उन्हें चुनना आपका काम है, और हर इस्तेमाल को कोई व्यक्ति मंज़ूर करता है।',
      selectReads: 'सिर्फ़ पढ़ने वाले चुनें',
      selectAll: 'सब चुनें',
      selectNone: 'कोई न चुनें',
      chosen: '{{count}} चुने गए',
      already: 'इस सेवा का टूल पहले से है',
      left: 'इसमें से छोड़ा गया:',
      skipped: 'जो अनुरोध टूल नहीं बन सकते ({{count}})',
      submit: 'चुने हुए टूल जोड़ें',
      needOne: 'कम से कम एक अनुरोध चुनें।',
      added: '{{count}} टूल जुड़ गए। वे आपकी समीक्षा का इंतज़ार करते हैं।',
    },
    endpointDialog: {
      addTitle: 'अनुरोध लिखें',
      addTitleTo: '{{name}} में अनुरोध जोड़ें',
      editTitle: '{{tool}} बदलें',
      description:
        'आपकी सेवा जो एक अनुरोध समझती है। एआई को बताया जाता है कि वह क्या करता है और कौन-से ब्योरे भरने हैं।',
      editWarning: 'सहेजने पर यह टूल समीक्षा में लौट जाता है और मंज़ूरी का इंतज़ार करते अनुरोध समाप्त हो जाते हैं।',
      title: 'टूल का नाम',
      titleHint: 'आपकी टीम को दिखता है, जैसे “ऑर्डर खोजें”।',
      about: 'एआई को बताया जाता है कि यह क्या करता है',
      aboutHint: 'बताएँ कि इसे कब इस्तेमाल करना है और यह क्या लौटाता है। इसे एआई के लिए लिखें।',
      method: 'मेथड',
      path: 'पाथ',
      pathHint: '/ से शुरू होता है। जहाँ कोई मान जाता है वहाँ {orderId} लिखें, जैसे /orders/{orderId}।',
      risk: 'यह क्या कर सकता है',
      riskDefault: 'मेथड से तय करें',
      details: 'एआई जो ब्योरे भरता है',
      detailsHint: 'हर एक वह मान है जो एआई अनुरोध के साथ देता है।',
      noDetails: 'कोई ब्योरा नहीं। अनुरोध जैसा है वैसा भेजा जाता है।',
      addDetail: 'ब्योरा जोड़ें',
      detailLabel: 'ब्योरा {{n}}',
      removeDetail: 'ब्योरा {{n}} हटाएँ',
      missing: 'पाथ में {{names}} है, लेकिन उसे कोई ब्योरा नहीं भरता।',
      fill: '{{name}} जोड़ें',
      detail: {
        name: 'नाम',
        nameHint: 'एआई इसे क्या कहता है: अक्षर, अंक और अंडरस्कोर।',
        place: 'कहाँ जाता है',
        places: {
          path: 'पाथ',
          query: 'क्वेरी',
          header: 'हेडर',
          body: 'JSON बॉडी',
        },
        key: 'अनुरोध में नाम',
        keyHint: 'सिर्फ़ तब, जब वह नाम से अलग हो।',
        type: 'मान का प्रकार',
        types: {
          string: 'टेक्स्ट',
          integer: 'पूर्ण संख्या',
          number: 'संख्या',
          boolean: 'हाँ या नहीं',
        },
        required: 'हमेशा ज़रूरी',
        requiredPath: 'हमेशा ज़रूरी, क्योंकि यह पाथ में है',
        about: 'यह क्या है',
      },
      errors: {
        title: 'टूल को एक नाम दें।',
        about: 'बताएँ कि टूल क्या करता है।',
        path: 'पाथ / से शुरू करें।',
        detailName: 'अक्षर, अंक और अंडरस्कोर इस्तेमाल करें, और अक्षर से शुरू करें।',
        detailDuplicate: 'दो ब्योरों का नाम एक ही है।',
      },
      submitAdd: 'टूल जोड़ें',
      submitEdit: 'सहेजें',
      added: '{{name}} जुड़ गया। वह आपकी समीक्षा का इंतज़ार करता है।',
      saved: '{{name}} सहेजा गया। वह फिर समीक्षा में है।',
    },
    editDialog: {
      title: '{{name}} बदलें',
      description: 'नाम या पता बदलें, या क्रेडेंशियल बदल दें।',
      name: 'सेवा का नाम',
      baseUrl: 'सेवा का पता',
      baseUrlWarning: 'नया पता टूल को समीक्षा में लौटा देता है। क्रेडेंशियल कभी किसी दूसरी साइट पर नहीं जाता।',
      credential: 'क्रेडेंशियल',
      keep: 'रखें',
      replace: 'बदल दें',
      remove: 'हटा दें',
      save: 'सहेजें',
      saved: '{{name}} सहेजा गया।',
      nothing: 'कुछ नहीं बदला।',
    },
    removeDialog: {
      title: '{{name}} हटाएँ?',
      body: 'इसके टूल बंद हो जाते हैं और सूची से हट जाते हैं, उन पर इंतज़ार करते अनुरोध रद्द हो जाते हैं, और इसका क्रेडेंशियल मिटा दिया जाता है। टूल ने जो किया वह कार्रवाई लॉग में रहता है।',
      confirm: 'हटाएँ',
      done: '{{name}} हटा दिया गया।',
    },
    tool: {
      service: 'कस्टम सेवा',
      request: 'अनुरोध',
      titleLabel: 'टूल का नाम',
      descriptionLabel: 'एआई को बताया जाता है कि यह क्या करता है',
      descriptionHint: 'एआई विवरण के शब्दों की जगह यह पढ़ता है। टूल चालू करने से पहले इसे जाँच लें।',
      errors: { title: 'टूल को एक नाम दें।', description: 'बताएँ कि टूल क्या करता है।' },
    },
  },
  memoryCard: {
    title: 'AI क्या याद रखता है',
    open: 'मेमोरी खोलें',
    none: 'यहाँ कुछ याद नहीं रखा गया है: यह विज़िटर अभी जाना-पहचाना ग्राहक नहीं है।',
    off: 'इस ब्रांड का AI मेमोरी का इस्तेमाल नहीं करता, इसलिए यहाँ की कोई चीज़ उसके जवाबों तक नहीं पहुँचती।',
    empty: 'इस ग्राहक के बारे में अभी कुछ याद नहीं रखा गया है।',
    note: 'AI सिर्फ़ मौजूदा वैल्यू इस्तेमाल करता है, और तभी जब ग्राहक ने याद रखे जाने की सहमति दी हो।',
    thisChat: 'यही बातचीत',
    pendingNote: 'कोई पुष्टि करे, तब तक इस्तेमाल नहीं होती।',
    review: 'समीक्षा करें',
    reviewLabel: '{{label}} की समीक्षा करें',
    correct: 'सुधारें',
    correctLabel: '{{label}} सुधारें',
    delete: 'हटाएँ',
    deleteLabel: '{{label}} हटाएँ',
    correctTitle: '“{{label}}” सुधारें',
    correctBody: 'नई वैल्यू इसकी जगह लेती है। पुरानी वैल्यू इतिहास में रहती है।',
  },
  playground: {
    title: 'अपने AI को आज़माएँ',
    description:
      'इस एजेंट से वैसे बात करें जैसे कोई ग्राहक करता है, उसी मॉडल के साथ जो वह सच में इस्तेमाल करता है। वह अपने निर्देशों और अपनी जानकारी से जवाब देता है। कुछ सेव नहीं होता, कुछ भी किसी ग्राहक या इनबॉक्स तक नहीं पहुँचता, और कोई टूल नहीं चलता। हर संदेश असली जवाब की तरह टोकन खर्च करता है।',
    testOnly: 'सिर्फ़ टेस्ट: कुछ भेजा या सेव नहीं होता',
    version: 'आज़माने के लिए वर्शन',
    versions: {
      draft: 'सेव किया ड्राफ़्ट (वर्शन {{version}})',
      published: 'लाइव वर्शन ({{version}})',
    },
    unsaved: 'कुछ बदलाव सेव नहीं हैं। टेस्ट सेव किए हुए ड्राफ़्ट पर चलता है, इसलिए उन्हें आज़माने से पहले सेव करें।',
    noVersion: 'इस एजेंट को आज़माने के लिए पहले ड्राफ़्ट सेव करें।',
    startOver: 'फिर से शुरू करें',
    you: 'आप, ग्राहक की तरह',
    ai: 'AI',
    message: 'आपका संदेश',
    messageHint: 'वह लिखें जो कोई ग्राहक लिख सकता है।',
    send: 'भेजें',
    thinking: 'AI जवाब दे रहा है…',
    empty: 'शुरू करने के लिए संदेश लिखें। ऐसा सवाल आज़माएँ जो आपके ग्राहक अक्सर पूछते हैं।',
    tooLong: 'यह टेस्ट बातचीत लंबी हो गई है। आगे आज़माने के लिए फिर से शुरू करें।',
    outcome: {
      customer_request:
        'ग्राहक ने किसी व्यक्ति से बात करने को कहा, इसलिए असली बातचीत यहाँ आपकी टीम के पास जाती।',
      assist_mode: 'यह एजेंट सिर्फ़ आपकी टीम को जवाब सुझाता है, इसलिए असली बातचीत उन्हीं के पास जाती।',
      ai_blocked:
        'AI अपने नियमों का पालन करने वाला जवाब नहीं लिख सका, इसलिए असली बातचीत आपकी टीम के पास जाती।',
      other: 'असली बातचीत यहाँ आपकी टीम के पास जाती।',
    },
    errors: {
      auth: 'मॉडल प्रोवाइडर ने API कुंजी या खाते को स्वीकार नहीं किया। मॉडल कनेक्शन जांचें।',
      rate_limited: 'मॉडल प्रोवाइडर अनुरोध सीमित कर रहा है। थोड़ी देर में फिर कोशिश करें।',
      overloaded: 'मॉडल प्रोवाइडर व्यस्त है। थोड़ी देर में फिर कोशिश करें।',
      unavailable: 'मॉडल प्रोवाइडर अभी उपलब्ध नहीं है।',
      timeout: 'मॉडल को जवाब देने में बहुत देर लगी।',
      aborted: 'अनुरोध रोक दिया गया।',
      invalid_request: 'मॉडल प्रोवाइडर ने अनुरोध स्वीकार नहीं किया। मॉडल का नाम और सेटिंग जांचें।',
      content_filtered: 'मॉडल प्रोवाइडर के फ़िल्टर ने जवाब रोक दिया।',
      context_length: 'बातचीत मॉडल के लिए बहुत लंबी है। फिर से शुरू करें।',
      no_credentials: 'इस मॉडल के लिए कोई API कुंजी नहीं है। पहले मॉडल कनेक्शन जोड़ें।',
      connection_disabled: 'मॉडल कनेक्शन बंद है। कोई दूसरा कनेक्शन चुनें।',
      provider_mismatch: 'मॉडल कनेक्शन उस प्रोवाइडर का नहीं है जिसे चुना गया है।',
      model_not_allowed: 'इस कनेक्शन पर यह मॉडल अनुमत नहीं है।',
      provider_not_supported: 'इस तरह का मॉडल समर्थित नहीं है।',
      empty_reply: 'मॉडल ने कुछ नहीं कहा।',
      unknown: 'मॉडल ने जवाब नहीं दिया।',
    },
    sources: 'इस्तेमाल किए गए स्रोत',
    actions: 'जो टूल उसने माँगे',
    actionsNote: 'टूल यहाँ कभी नहीं चलते। यह दिखाता है कि असली बातचीत में क्या होता।',
    decisions: {
      would_run: 'अभी चल जाता',
      needs_approval: 'मंज़ूरी माँगता',
      denied: 'अनुमति नहीं',
      invalid: 'ग़लत ब्योरा',
    },
    details: 'उसने जो ब्योरा भेजा',
    steps: 'चरण ({{total}})',
    stepsLabel: 'AI ने इस जवाब के लिए क्या किया',
    stats: 'मॉडल {{model}} · टोकन: {{input}} अंदर, {{output}} बाहर · {{time}}',
    statsNoModel: 'कोई मॉडल नहीं चलाया गया · {{time}}',
  },
};
